import { useMemo } from "react";
import { getLastCustomerEta } from "../utils/routeTime";

const useRouteData = backhaulGroup => {
  return useMemo(() => {
    const {
      allRouteIds,
      allStops,
      backhaulGroupCount,
      distances,
      completionTime
    } = backhaulGroup.reduce(
      (
        {
          allRouteIds,
          allStops,
          backhaulGroupCount,
          distances,
          completionTime
        },
        routeGroup,
        index
      ) => {
        const isLastItem = index === backhaulGroup.length - 1;

        return {
          // Route ids
          allRouteIds: allRouteIds.concat(routeGroup.id),
          // Stops
          allStops: isLastItem
            ? allStops.concat(routeGroup.stops).flat()
            : allStops.concat(routeGroup.stops),
          // Filter and get only real routes which have at least one stop
          backhaulGroupCount:
            routeGroup.stops.length > 2
              ? backhaulGroupCount + 1
              : backhaulGroupCount,
          distances: routeGroup.distances + distances,
          completionTime: routeGroup.completion_time + completionTime
        };
      },
      {
        allRouteIds: [],
        allStops: [],
        backhaulGroupCount: 0,
        distances: 0,
        completionTime: 0
      }
    );

    const {
      unitsCount,
      allNonStartEndStops,
      allStarts,
      allEnds,
      allNonStartEndBreakStops
    } = allStops.reduce(
      (
        {
          unitsCount,
          allNonStartEndStops,
          allStarts,
          allEnds,
          allNonStartEndBreakStops
        },
        stop
      ) => {
        return {
          // All route stops units count
          unitsCount:
            stop.units?.reduce((count, unit) => count + unit.quantity, 0) +
            unitsCount,
          // Stops with Break
          allNonStartEndStops:
            stop.type !== "start" && stop.type !== "end"
              ? allNonStartEndStops.concat(stop)
              : allNonStartEndStops,
          // Clean stops without break & end & start
          allNonStartEndBreakStops:
            stop.type !== "start" &&
            stop.type !== "end" &&
            stop.type !== "break"
              ? allNonStartEndBreakStops.concat(stop)
              : allNonStartEndBreakStops,
          // All route stops start
          allStarts: stop.type === "start" ? allStarts.concat(stop) : allStarts,
          // All route stops end
          allEnds: stop.type === "end" ? allEnds.concat(stop) : allEnds
        };
      },
      {
        unitsCount: 0,
        allNonStartEndStops: [],
        allStarts: [],
        allEnds: [],
        allNonStartEndBreakStops: []
      }
    );
    // Is link disabled
    const linkDisabled = !allNonStartEndStops.length;
    // Only start & end stops;
    const startEndStops =
      allNonStartEndStops.length > 0 &&
      allStops.length !== allNonStartEndStops.length
        ? [allStarts[0], allEnds[allStarts.length - 1]]
        : null;

    return {
      allRouteIds,
      allStops,
      backhaulGroupCount,
      distances,
      completionTime,
      unitsCount,
      startEndStops,
      allStarts,
      allEnds,
      linkDisabled,
      allNonStartEndBreakStops,
      // ETA at the last customer (seconds-of-day) — FOJW steers on this, not the depot return.
      lastCustomerEta: getLastCustomerEta(allStops),
      mainRoute: backhaulGroup[0]
    };
  }, [backhaulGroup]);
};

export default useRouteData;
